module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-5-8ab03dff48aa0f06c2e8d42b8b3bc1b7.svg";